<template>
  <div class="row d-flex flex-nowrap justify-content-around w-100 text-center mt-3">
    <div class="small col">
      <img alt="secure" class="icon" :src="lockSvg" />
      Encrypted and secure payments
    </div>
    <div class="small col align-top">
      <img alt="money back" class="icon" :src="clockRotateLeftSvg" />
      30-Day Money Back Guarantee
    </div>
  </div>
</template>

<script setup>
import lockSvg from '@/assets/svg/lock.svg';
import clockRotateLeftSvg from '@/assets/svg/clock-rotate-left.svg';
</script>
